import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  url = 'https://api.crystal.com.tr/user.php';
  logUrl = 'https://api.crystal.com.tr/log.php';

  username: any = '';
  password: any = '';

  constructor(
    private http: HttpClient,
    private router: Router,
    private storage: Storage
  ) {}

  getData() {
    const sub = new Subject();

    const header = new Headers();
    header.append('Content-Type', 'application/x-www-form-urlencoded');

    var body = {
      username: this.username,
      password: this.password,
    };
    this.storage.get('user').then((val) => {
      body = val;
      const options = {
        method: 'POST',
        body: new URLSearchParams(body),
        header: header,
      };

      fetch(this.url, options).then((res) => {
        res.json().then((res1) => {
          sub.next(res1);
        });
      });
    });
    return sub.asObservable();
  }

  getLogs(name, date) {
    const sub = new Subject();

    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

    let urlencoded = new URLSearchParams();
    urlencoded.append('macname', name);
    urlencoded.append('date', date);

    let requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
    };

    fetch(this.logUrl, requestOptions).then((response) =>
      response.text().then((result) => {
        let res = result.split('\n').map((item) => {
          return item
            .slice(1, -1)
            .replace(/'/g, ' ')
            .replace(/\s/g, '')
            .split(',');
        });
        sub.next(res);
      })
    );
    return sub.asObservable();
  }

  login(credentials: { email; password }): Observable<any> {
    let data = {
      username: (this.username = credentials.email),
      password: (this.password = credentials.password),
    };

    const response = new Subject<any>();
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

    const request = new Request(this.url, {
      method: 'POST',
      body: new URLSearchParams(data),
      headers: myHeaders,
    });
    fetch(request).then((resp) => {
      resp.text().then((res) => {
        // console.log(res);
        if (res == ' şifre doğru değil') {
          response.error({ data: ' şifre doğru değil' });
        } else {
          response.next(res);
          this.storage.set('user', data);
          this.storage.set('hasLoggedIn', true);
        }
      });
    });
    return response.asObservable();
  }

  async isLoggedIn() {
    return await this.storage.get('hasLoggedIn');
  }
}
